import { render, staticRenderFns } from "./ProgramOfStudyModal.vue?vue&type=template&id=1f340ed6&scoped=true&lang=pug&"
import script from "./ProgramOfStudyModal.vue?vue&type=script&lang=js&"
export * from "./ProgramOfStudyModal.vue?vue&type=script&lang=js&"
import style0 from "./ProgramOfStudyModal.vue?vue&type=style&index=0&id=1f340ed6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f340ed6",
  null
  
)

export default component.exports